import React, { Component, ReactNode } from 'react';
import errorImage from '../../assets/images/ErrorBoundary.png'; // caminho relativo

interface ErrorBoundaryProps {
  children: ReactNode;
}

interface ErrorBoundaryState {
  hasError: boolean;
}

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
  constructor(props: ErrorBoundaryProps) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
    console.error('Erro capturado pelo ErrorBoundary:', error, errorInfo);
  }

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      return (
        <div className="d-flex flex-column justify-content-center align-items-center vh-90 text-center p-4">
          <img
            src={errorImage}
            alt="Erro ao carregar"
            style={{ maxWidth: '3000px', marginBottom: '20px' }}
          />
          <h4 className="fw-bold mb-2">Aaah! Algo deu errado</h4>
          <p className="text-muted mb-3" style={{ maxWidth: '400px' }}>
            Segure firme enquanto resolvemos o problema.<br />
            Você também pode tentar recarregar a página ou voltar mais tarde.
          </p>
          <button className="btn btn-primary" onClick={this.handleReload}>
            Recarregar página
          </button>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
